import React from 'react';
import { withRouter } from 'react-router-dom';
import { isPast } from 'helpers/dates';
import BlobImage from 'components/blobImage';
import { SystemText } from 'e4shared';

const getStatus = (completed, due) => {
    const st = (s, x) => SystemText(`Search/Results/Objective/${s}`, x);
    if (completed) {
        return <label className="label label-success">{st('Complete')}</label>;
    } else if (isPast(due)) {
        return <label className="label label-danger">{st('Overdue')}</label>;
    } else {
        return <label className="label label-warning">{st('Outstanding')}</label>;
    }
};

export const Task = props => {
    const { data, history, userId } = props;
    const isMe = data.extras3 === userId.toString();
    const st = (s, x) => SystemText(`Search/Results/Objective/${s}`, x);
    return (
        <div className="search-result box" onClick={() => history.push(`/objectives/${data.extras3}/objective/${data.id}`)}>
            <div className="image-holder hidden-xs">
                <i className="fa fa-calendar" />
            </div>
            <div>
                <label className="label label-primary">
                    <i className="mr10 fa fa-comments" />
                    {st('Title')}
                </label>
                <h2>{data.name}</h2>
                {!isMe && (
                    <div className="flex flex-center">
                        <div className="mr5 profile-image hidden-xs">
                            <BlobImage folder="avatar" initials={data.initials} src={data.extras4} />
                        </div>
                        <div className="flex-grow">{data.extras5}</div>
                    </div>
                )}
                <p>{data.summary}</p>
                <span>{getStatus(data.extras1, data.extras2)}</span>
            </div>
        </div>
    );
};

export default withRouter(Task);
